import liveswitch from "fm.liveswitch";
import ChannelConnectionEvents from "./ChannelConnectionEvents";
import ConnectionData from "./ConnectionData";

export default class Messager {
    private channel: liveswitch.Channel;
    private events: ChannelConnectionEvents;
    private errorLogger: (err: string) => void;

    constructor(channel: liveswitch.Channel, events: ChannelConnectionEvents, errorLogger: (err: string) => void) {
        this.channel = channel;
        this.events = events;
        this.errorLogger = errorLogger;

        this.channel.addOnMessage(this.onMessage.bind(this));
    }

    public sendChatMessage(message: string): Promise<void> {
        return new Promise((resolve, reject) => {
            this.channel.sendMessage(message).then(() => {
                console.log("Sent message: " + message);
                resolve();
            }).fail(ex => {
                this.errorLogger(ex.message);
                reject();
            });
        });
    }

    private onMessage(clientInfo: liveswitch.ClientInfo, message: string) {
        this.events.notify("onmessage", { user: clientInfo.getUserAlias(), message });
    }

    public requestScreenshot(connectionData: ConnectionData): Promise<VideoFrameData> {        
        console.log(`User ${this.channel.getUserId()} requested a screenshot from ${connectionData.userId}`);
        //this.channel.sendDeviceMessage(connectionData.userId, connectionData.deviceId, "screenshot");
        this.channel.sendUserMessage(connectionData.userId, "screenshot");

        return new Promise((resolve, reject) => {
            this.channel.addOnDeviceMessage((_, data: string) => {
                const videoFrameData = JSON.parse(data);
                resolve(videoFrameData);
            });
    
            setTimeout(() => {
                reject("Screenshot request timeout");
            }, 10000);
        });
    }

    public sendImage(connectionData: ConnectionData, imageAnnotationData: ImageAnnotationData): liveswitch.Future<Object> {
        return this.channel.sendDeviceMessage(connectionData.userId, connectionData.deviceId, JSON.stringify(imageAnnotationData));
    }
}
